import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { SectionHowItWorks } from '../../components';
import css from './SweepstakesPage.module.css';

const SweepstakesPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <StaticPage
      title="Sweepstakes"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SweepstakesPage',
        description: 'Sweepstakes',
        name: 'Sweepstakes',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div>
            <div className={css.introSection}>
              <h1 className={css.title}>Lenddit’s Giveaway Sweepstake #2</h1>
              <h2 className={css.title}>Official Rules</h2>
              <h3 className={css.title}>Lenddit</h3>
              <h4 className={css.title}>
                <strong>#2 Official Rules</strong>
              </h4>
            </div>
            <div className={css.staticPageWrapper}>
              <p className={css.text}>
                <strong>
                  NO PURCHASE OR PAYMENT NECESSARY. A PURCHASE OR PAYMENT WILL NOT INCREASE YOUR
                  CHANCE OF WINNING. PROMOTION IS OPEN TO LEGAL RESIDENTS OF THE OHIO COUNTIES,
                  Delaware, Franklin, Madison, Union, 18 YEARS OF AGE OR OLDER AT TIME OF ENTRY.
                  VOID IN PUERTO RICO, QUEBEC, AND WHERE ELSE PROHIBITED, INCLUDING OUTSIDE THE
                  SPECIFIED COUNTIES.
                </strong>
              </p>

              <h3>PROMOTION PERIOD:</h3>
              <p>
                The Lenddit’s Giveaway® #2 (the “Sweepstakes”) begins at 12:01:00 a.m. Eastern
                Time (“ET”) on October 10, 2023 and ends at 11:59:59 p.m. ET on December 3, 2023
                (the “Promotion Period”).
              </p>
              <h3>ELIGIBILITY:</h3>
              <p>
                Eligibility for the Sweepstakes is restricted to permanent legal residents of Ohio
                counties Delaware, Franklin, Madison, Union, who are 18 years of age or older and
                hold a valid driver's license. The Sweepstakes is void wherever it is prohibited or
                restricted by law. Individuals who are employees, board members, advisory committee
                members, directors, officers, agents, or suppliers to Lenddit Inc (the “Sponsor”),
                (collectively the “Releasees”) their affiliates, subsidiaries, advertising and
                promotion agencies, and their immediate families (spouses, parents, children,
                siblings, and their respective spouses, regardless of their residence), as well as
                individuals living in their households, are ineligible to participate. Participation
                in the Sweepstakes is subject to all federal, state, and local laws and regulations.
                By entering the Sweepstakes, participants agree to be bound by the Official Rules,
                and winning a prize is contingent upon fulfilling all requirements set forth in the
                Official Rules.
              </p>
              <h3>HOW TO ENTER</h3>
              <ol>
                <li>
                  Automatic Entry Through Registering on Lenddit’s website: Eligible individuals who
                  are or will register on the Sponsor's website,{' '}
                  <a href="https://www.Lenddit.com"> www.Lenddit.com.</a>, during the promotion
                  period, by being registered, signing up and completing all contact information
                  will automatically receive one (1) Sweepstakes entry. There is a limit of one (1)
                  entry per household made by signing up and completing all contact information on{' '}
                  <a href="https://www.Lenddit.com"> www.Lenddit.com</a>. All contact information
                  includes email address, phone number and home address. Any attempt by you to
                  obtain more than one (1) Entry per household by using multiple/different email
                  addresses, identities, registrations, or logins, or any other methods may void
                  your Entries and you may be disqualified from the Promotion.
                  <p>
                    For eligibility, the signing up and completion of all contact details, email
                    address and email verification, phone number, Home address, must be received by
                    11:59:59 p.m. ET on December 4, 2023. There is an additional five (5) entries
                    for completing both (a.) a front facing profile picture, that clearly shows your
                    face and head without obstruction, and (b.) completing a brief bio about
                    yourself. The number of Entries will be one (1) for each complete registration.
                    All registrations and profile pictures are subject to the Sponsor's policy.
                  </p>
                </li>
                <li>
                  Automatically via a rental. Eligible individuals who make an online rental on
                  Lenddit's website at <a href="https://www.Lenddit.com"> www.Lenddit.com</a>,
                  during the promotion period, will automatically receive one (1) Sweepstakes entry
                  for each $1.00 spent on an eligible rental (example: rent $100 worth of items from{' '}
                  <a href="https://www.Lenddit.com"> www.Lenddit.com</a> and receive 100 entries
                  into the Sweepstakes). There is no limit on the number of entries received with a
                  rental on <a href="https://www.Lenddit.com"> www.Lenddit.com</a>.
                  <p>
                    Rental transactions must be received by 11:59:59 p.m. ET December 4, 2023 to be
                    eligible to receive entries. The number of entries you receive will be based on
                    the listed price of your eligible rental (excludes sales tax and shipping
                    charges) and will be rounded up to the nearest dollar. If a rental is canceled
                    prior to the drawing, entry/ies associated with that rental will be voided. All
                    rentals are subject to Lenddit's rental policy.
                  </p>
                </li>
                <li>
                  Automatic Entry Through listing an eligible tool or equipment for rent: Eligible
                  individuals who make a tool or equipment listing on Sponsor’s website at{' '}
                  <a href="https://www.Lenddit.com"> www.Lenddit.com.</a>, during the promotion
                  period, will automatically receive twenty (20) Sweepstakes entries for each
                  completed listing on an eligible tool or equipment (example: listing one eligible
                  tool on <a href="https://www.Lenddit.com"> www.Lenddit.com.</a> and receive 20
                  entries into the Sweepstakes). The listing must have a picture of the tool, No
                  limit on number of entries received with unique tool or equipment listing on{' '}
                  <a href="https://www.Lenddit.com"> www.Lenddit.com.</a>
                  <p>
                    Tool or equipment listings must be posted by 11:59:59 p.m. ET December 4, 2023
                    to be eligible to receive entries. The number of entries you receive will be
                    based on how many unique eligible tool or equipment listings you post with
                    completed information. Individuals must complete the tool name, description,
                    serial number, if one is listed, tool type, brand, number owned of unique items,
                    tool rules, location of the tool, price, availability, and photo/s. Tool/s or
                    equipment with incomplete information are prohibited, entry/ies associated with
                    that rental will be voided. Tool/s or equipment with less than half of each
                    month available for rental are prohibited, entry/ies associated with that rental
                    will be voided. If a tool or equipment listing is deactivated prior to the
                    drawing, entry/ies associated with that rental will be voided. All listings of
                    tools and equipment eligible for sponsorship must comply with Sponsor's policy
                    and meet the minimum value requirement of $100 USD. Sponsor reserves the right
                    to disqualify any listings that do not meet these criteria.
                  </p>
                </li>
              </ol>
              <ol start="4">
                <li>
                  To enter the Sweepstakes without a rental, eligible individuals must{' '}
                  <strong>handwrite</strong> their full name, address, city, state/province,
                  zip/postal code, e-mail address, telephone number, and date of birth on the front
                  of a 3x5 card. The card must be inserted in a #10 envelope and mailed to: Lenddit
                  Inc Giveaway #1, P.O. Box 20662 Columbus, OH 43220 (each envelope must be mailed
                  individually). The{' '}
                  <strong>
                    return address and Lenddit Inc. mailing address must be handwritten
                  </strong>
                  . All mail-in entries must be postmarked by December 4, 2023 and received by
                  December 8, 2023 and include all the required information as stated above. Bulk
                  shipments (multiple entries in one shipping package) will not be accepted and will
                  be destroyed. Each mail-in entry will receive five (5) entries into the
                  Sweepstakes. There is no limit on the number of entries received via the no
                  purchase method of entry (mail-in entries). Requests for confirmation of receipt
                  of mail-in entries will not be acknowledged. No photocopies, facsimiles, or
                  reproductions of the mail-in entry will be accepted. The Sponsor is not
                  responsible for late, lost, damaged, stolen, incomplete, illegible, postage due,
                  or misdirected entries. Proof of mailing does not constitute proof of delivery.
                  Metered mail will not be accepted.
                </li>
              </ol>
              <p>
                To be eligible for the Sweepstakes, all required information must be fully and
                accurately provided. The use of automated, robotic, repetitive, programmed or
                similar entry methods or agents (including, but not limited to, sweepstakes entry
                services) means, including computer programs, to enter the Sweepstakes is strictly
                prohibited and will void all Entries by you. In the event of a dispute regarding any
                online entry, the entrant shall be deemed to be the Authorized Account Holder of the
                email address used to submit the entry. The term "Authorized Account Holder" shall
                refer to the natural person who has been assigned an email address by an internet
                access provider, online service provider, or any other organization responsible for
                assigning email addresses for the domain associated with the submitted address. The
                prospective Grand Prize Winner may be required to provide evidence demonstrating
                their status as the Authorized Account Holder.
              </p>
              <p>
                Please be advised that all prior registrations and tool listings on Lenddit that
                comply with the stipulated guidelines will be considered as valid entries for the
                Sweepstakes. This includes individuals who have successfully registered and
                completed their profiles, as well as those who have listed tools or equipment for
                rent on the platform. Each completed registration is equivalent to one entry, while
                each tool or equipment listing corresponds to twenty entries. Consequently, the
                quantity of tools listed can directly influence the probability of winning. However,
                it is imperative that all listings adhere to the established criteria, which include
                a clear image of the tool, comprehensive information, and a minimum availability of
                half of each month. We encourage all participants to ensure their entries are in
                compliance with these guidelines.
              </p>
              <p>
                Mail-in entries that fail to comply with the specified format, are illegible,
                inaccurate, incomplete, or have been reproduced through photocopying or similar
                means, will be deemed null and void. Mere proof of submission will not serve as
                evidence of receipt. The Released Parties are not responsible for lost, late,
                unreadable, mutilated, misdirected, postage-due, or entries not received by the
                deadline. All submitted materials become the property of the Sponsor and will not be
                returned. No correspondence will be acknowledged or entered into, and requests for
                confirmation of receipt of mail-in entries will not be acknowledged.
              </p>
              <h2>Publicity Grant:</h2>
              <p>
                Subject to applicable laws, by participating in the Promotion, you grant to the
                Promotion Entities the perpetual and worldwide right to use your name, image,
                likeness, statements, biographical information, voice, entry, and state of residency
                for promotional and advertising purposes in any and all media, without further
                compensation, notification, or permission. The personal information collected from
                entrant may be used for the purpose of the Sweepstakes and may be re-used, sold, or
                shared for future Sponsor's or prize partner's products and promotions. Should you
                be featured in any of the Sponsor's on-air presentations, you agree to execute any
                necessary agreements and releases related to your services and performances. This
                includes on-location or studio appearances, footage captured when the potential
                Grand Prize Winner is contacted, and any photographs, videos, or other materials
                submitted by the Grand Prize Winner to the Sponsor.
              </p>

              <h2>GRAND PRIZE DRAWING:</h2>
              <p>
                The Grand Prize winner shall be determined through a random drawing held on or
                around December 10, 2023, under the supervision and discretion of Lenddit, Inc.,
                whose decisions shall be final and binding with respect to all matters pertaining to
                this Sweepstakes.
              </p>

              <p>
                <strong>
                  The Odds of winning a Grand Prize depend on the number of eligible entries
                  received.
                </strong>
              </p>

              <h2>PRIZES:</h2>
              <p>
                There is a total of three prizes offered in this Sweepstakes with a maximum total
                approximate retail value (“ARV”) of $500.
              </p>
              <ul>
                <li>
                  <strong>Grand Prize:</strong> a Gift card, actual retail value (“ARV”) of $300.
                </li>
                <li>
                  <strong>Secondary Prize:</strong> a Gift card, actual retail value (“ARV”) of
                  $125.
                </li>
                <li>
                  <strong>Third Prize:</strong> a Gift card, actual retail value (“ARV”) of $75.
                </li>
              </ul>

              <h2>GRAND PRIZE DETAILS:</h2>
              <p>
                The Grand Prize Winner shall be responsible for any expenses not explicitly stated
                as included with the prize, and must present a valid driver's license and additional
                evidence of eligibility, if applicable, prior to receiving the prize. The Winner
                must either retrieve the Gift Card within 30 days from the date of confirmation of
                their winning status from the Sponsor's address (P.O. Box 20662 Columbus, OH 43220)
                or will be certified mailed to the Winner’s address provided on sweepstakes
                registration, unless otherwise communicated by the Sponsor. The Winner shall be
                responsible for all associated costs and fees incurred during the retrieval of the
                prize, including but not limited to airfare, gasoline, temporary registration,
                insurance, miscellaneous fees, etc. The prize shall be awarded "AS IS" and without
                any express or implied warranty of any kind, including but not limited to any
                warranty of merchantability for a specific purpose. Failure to retrieve the prize
                within 30 days of its availability may result in forfeiture of the prize and
                awarding it to an alternate. Substitution or transfer of the prize is strictly
                prohibited, except at the sole discretion of the Sponsor. Pursuant to the Credit
                Card Accountability Responsibility and Disclosure (CARD) Act of 2009, gift cards
                cannot expire within five years from the date of activation and generally prohibits
                inactivity fees, except in specific circumstances such as if there has been no
                transaction for at least twelve months.
              </p>
              <p>
                The Prize Winner shall be responsible for the payment of any taxes imposed on the
                Prize, if applicable, and for any other costs and expenses incurred in connection
                with the acceptance and use of the Prize. The Sponsor reserves the right to
                substitute the Prize with another prize of equal or greater value at any time during
                the duration of the Sweepstakes.
              </p>

              <h2>PRIZE GENERAL RULES:</h2>
              <p>
                The Grand Prize Potential Winner will be notified by means of email, followed by a
                phone call, on or around December 10, 2023. In order to claim the Grand Prize, the
                Potential Winner must sign and return an Affidavit of Eligibility, Publicity and
                Liability Release, and a W9 (where applicable and required by law) within 24 hours
                of the attempted notification. If the Potential Winner is determined to be a minor,
                the prize will be forfeited. Failure to return the required documents within the
                stated timeframe will result in the Potential Winner being disqualified, and an
                alternate winner will be selected from among all eligible entries. If a Potential
                Winner decides to decline the prize for any reason, the Sponsor will have no further
                obligation to that Potential Winner, and an alternate winner may be selected, if
                time permits. If the Potential Winner is selected based on an entry with multiple
                items of that same tool or equipment, the Potential Winner must produce evidence of
                owning that number of items. If the Potential Winner fails to produce the number of
                items claimed, the Sponsor will have no further obligation to that Potential Winner,
                and an alternate winner may be selected, if time permits. The payment of taxes
                related to the prize is the sole responsibility of the Winner. By accepting the
                Prize, the Winner consents to the use of their name and/or likeness by the Sponsor
                and its agencies for advertising and promotional purposes without further
                compensation, unless prohibited by law. The Winner agrees to indemnify and hold the
                Releasees harmless from any and all claims, liabilities, damages, or expenses
                arising from any accident, loss, injury, or damage occurring in connection with the
                promotion or in any way related to the Prize or its use/misuse. Prize substitution
                or transfer is prohibited, except at the sole discretion of the Sponsor. The
                Releasees shall not be held responsible for any printing errors or delays in mail
                service. All entries become the property of the Sponsor and will not be acknowledged
                or returned. By participating in this promotion, the Entrants agree to be bound by
                these Official Rules and the decisions of the Sponsor, which are final and binding.
                Any inquiries, comments, or complaints regarding the promotion should be directed to
                the Sponsor at the specified address.
              </p>

              <h2>SCAMMER ALERT INFORMATION:</h2>
              <p>
                The payment of handling fees, service fees, or any other charges prior to receiving
                a prize is an indication of a sweepstakes scam and should not be pursued. The tax
                obligations related to the prize must be fulfilled directly with the Internal
                Revenue Service (IRS) as part of the entrant's regular tax return. For additional
                information, kindly refer to the provided source at{' '}
                <a href="https://www.consumer.ftc.gov/articles/fake-prize-sweepstakes-and-lottery-scams">
                  https://www.consumer.ftc.gov/articles/fake-prize-sweepstakes-and-lottery-scams
                </a>
                .
              </p>

              <h2>WAIVERS, DISCLAIMERS, RELEASES, INDEMNITY:</h2>
              <p>
                BY PARTICIPATING IN THE SWEEPSTAKES, ENTRANT AGREES THAT TO THE EXTENT PERMITTED BY
                APPLICABLE LAW: (1) ANY AND ALL DISPUTES, CLAIMS, AND CAUSES OF ACTION ARISING OUT
                OF OR CONNECTED WITH THE SWEEPSTAKES OR ANY PRIZE AWARDED SHALL BE RESOLVED
                INDIVIDUALLY, WITHOUT RESORT TO ANY FORM OF CLASS ACTION; (2) ANY AND ALL CLAIMS,
                JUDGMENTS, AND AWARDS SHALL BE LIMITED TO ACTUAL THIRD-PARTY, OUT-OF-POCKET COSTS
                INCURRED (IF ANY), NOT TO EXCEED FIVE DOLLARS ($5.00), AND IN NO EVENT SHALL
                ATTORNEYS' FEES BE AWARDED OR RECOVERABLE; (3) UNDER NO CIRCUMSTANCES SHALL ANY
                ENTRANT BE PERMITTED TO OBTAIN ANY AWARD FOR, AND ENTRANT HEREBY KNOWINGLY AND
                EXPRESSLY WAIVES ALL RIGHTS TO SEEK, PUNITIVE, INCIDENTAL, CONSEQUENTIAL, OR SPECIAL
                DAMAGES, LOST PROFITS, AND/OR ANY OTHER DAMAGES OTHER THAN ACTUAL OUT-OF-POCKET
                EXPENSES NOT TO EXCEED FIVE DOLLARS ($5.00), AND/OR ANY RIGHTS TO HAVE DAMAGES
                MULTIPLIED OR OTHERWISE INCREASED; AND (4) ENTRANT'S REMEDIES ARE LIMITED TO A CLAIM
                FOR MONEY DAMAGES (IF ANY), AND ENTRANT IRREVOCABLY WAIVES ANY RIGHT TO SEEK
                INJUNCTIVE OR EQUITABLE RELIEF. SOME JURISDICTIONS DO NOT ALLOW THE LIMITATIONS OR
                EXCLUSION OF LIABILITY, SO THE ABOVE MAY NOT APPLY TO YOU.
              </p>
              <p>
                EACH ENTRANT SHALL BE BOUND BY THE TERMS OF THESE OFFICIAL RULES AND THE DECISIONS
                OF THE SWEEPSTAKES ENTITIES, WHICH SHALL BE FINAL AND BINDING ON ALL MATTERS RELATED
                TO THE SWEEPSTAKES. BY PARTICIPATING IN THE SWEEPSTAKES, EACH ENTRANT AGREES TO
                RELEASE, DISCHARGE, INDEMNIFY AND HOLD HARMLESS THE RELEASED PARTIES FROM ANY AND
                ALL CLAIMS OR LIABILITY ARISING FROM OR IN CONNECTION WITH THEIR PARTICIPATION IN
                THE SWEEPSTAKES, OR ACCEPTANCE OR USE OF ANY PRIZE, INCLUDING, BUT NOT LIMITED TO,
                ANY RELATED ACTIVITY.
              </p>
              <h2>INTERNET:</h2>
              <p>
                The Releasees and any internet access or service providers shall not be held liable
                for any incorrect or inaccurate entry information, human error, technical
                malfunctions, lost or delayed data transmission, omission, interruption, deletion,
                defect, line failures of any telephone network, computer equipment, software, or
                combination thereof, inability to access websites, or damage to a participant's
                computer system (hardware or software) in connection with participation in this
                Sweepstakes. The Sponsor, in its sole discretion, reserves the right to void any
                entries suspected of electronic tampering with the Sweepstakes, or if technical
                difficulties compromise its integrity, or if there is any non-compliance with the
                rules. In such cases, the Sponsor may terminate the Sweepstakes and conduct a random
                drawing using all eligible, non-suspect entries received in the applicable drawing
                pool as of the end of the promotion. In the event of termination of the Sweepstakes
                due to tampering or technical difficulties, notice shall be posted at the website{' '}
                <a href="http://www.Lenddit.com">www.Lenddit.com</a>. Any attempt to intentionally
                disrupt the content or operation of this Sweepstakes shall be considered unlawful
                and may result in legal action by the Sponsor or its authorized agents. The
                authorized account holder of the email address submitted at the time of entry shall
                be deemed the entrant. The authorized account holder is defined as the natural
                person assigned to the email address by an Internet service provider, online service
                provider, or other organization responsible for assigning email addresses. Automated
                or third-party entries will be disqualified. Entries shall not be considered valid
                until receipt by the Sponsor.
              </p>

              <h2>DISPUTES AND CHOICE OF LAW:</h2>
              <p>
                The Entrant hereby agrees to resolve any claims or disputes arising under or in
                connection with the Sweepstakes, the Official Rules, or the Sponsor's and/or
                Administrator's Privacy Policy, through the dispute resolution process set forth in
                this Dispute Resolution section. The Entrant acknowledges the importance of reading
                this section carefully, as it impacts their rights and the resolution of any claims
                against the Sponsor and/or Administrator. In the event of a disagreement between the
                Entrant and the Sponsor and/or Administrator, relating to the Sweepstakes, the
                Official Rules, or the Sponsor's and/or Administrator's Privacy Policy, the Entrant
                shall provide written notice to the Sponsor (hereinafter referred to as "Demand").
                The Entrant agrees that the provisions of this Dispute Resolution section shall
                apply even to disputes that may have arisen prior to the Entrant's acceptance of the
                Official Rules or the Sponsor's and/or Administrator's Privacy Policy. The Demand
                shall be sent to the following Notice Address: Lenddit Inc, P.O. Box 20662 Columbus,
                OH 43220, Attention; Legal Department.
              </p>
              <p>
                The Entrant hereby covenants and agrees that prior to initiating any legal
                proceedings, including but not limited to the filing of a lawsuit or demand for
                arbitration, the Entrant shall provide written notice (hereinafter referred to as
                the "Demand") to the Sponsor, Lenddit Inc, at the Notice Address of P.O. Box 20662
                Columbus, OH 43220, Attention: Legal Department, regarding any claim or dispute
                arising out of, connected to, or in any way related to the Sweepstakes, the Official
                Rules, or the Sponsor's and/or Administrator's Privacy Policy. The Entrant agrees to
                allow a period of ten (10) business days from the date of receipt of the Demand for
                the resolution of such claim or dispute. If the disagreement stated in the Demand is
                not resolved to the Entrant's satisfaction within ten (10) business days, and the
                Entrant intends to initiate legal proceedings, the Entrant agrees to file a demand
                for arbitration with the American Arbitration Association (the "Arbitrator").
              </p>
              <p>
                This arbitration provision shall have the effect of limiting the Entrant's, the
                Administrator's, and the Sponsor's ability to litigate claims in a court of law and
                each party, the Entrant, the Administrator, and the Sponsor, hereby waives their
                respective rights to a trial by jury or before a state or federal judge. The Entrant
                further covenants and agrees not to file any lawsuit against the Administrator or
                the Sponsor in any state or federal court and acknowledges that in the event the
                Entrant files a lawsuit in violation of this provision and the Administrator or
                Sponsor prevails in a motion to compel arbitration, the Entrant shall be responsible
                for paying all fees and costs incurred by the Administrator and Sponsor in
                connection with such motion, including reasonable attorney's fees.
              </p>
              <p>
                For the purpose of filing a demand for arbitration, proper service under the rules
                of the Arbitrator must be effectuated and notice to the Notice Address may not be
                sufficient. In the event the American Arbitration Association is unable to conduct
                the arbitration, the Entrant may file its case with any national arbitration
                company. The Arbitrator shall apply the AAA Consumer Arbitration Rules effective
                September 1, 2014 (as may be amended from time to time) and as modified by the
                agreement to arbitrate set forth in this Dispute Resolution section. The Entrant
                agrees that the Arbitrator shall have sole and exclusive jurisdiction over any and
                all disputes between the Entrant and the Administrator or Sponsor.
              </p>
              <p>
                The Federal Arbitration Act governs the enforcement of arbitration agreements and
                interpretation of the agreement to arbitrate between the Entrant, Administrator, and
                Sponsor. The arbitration shall take place in Columbus, Ohio. The Entrant waives its
                rights to file a class action or collective action against Administrator or Sponsor,
                and further waives its right to participate in any class action or collective action
                against them. The Entrant further agrees not to consolidate its claims with those of
                any other person. Should the class action waiver be deemed invalid, the agreement to
                arbitrate shall be null and void, and any arbitration disputes may be refiled in a
                court. Neither Entrant, Administrator, nor Sponsor agrees to class or collective
                procedures in arbitration or the consolidation of claims in arbitration. All
                disputes with Entrant shall be submitted to arbitration before the Arbitrator. The
                interpretation and enforcement of these Official Rules, and the rights and
                obligations of Entrant and Sponsor in connection with the Sweepstakes, shall be
                governed by the laws of the State of Ohio, excluding any conflict of law principles.
                This arbitration provision shall remain in effect after the conclusion,
                modification, or termination of the Sweepstakes, and after any suspension,
                revocation, closure, modification, or amendment to the Official Rules, and any
                aspect of the relationship of the parties arising from participation in the
                Sweepstakes.
              </p>
              <p>
                WINNERS LIST: Winners will be posted on{' '}
                <a href="https://www.Lenddit.com/giveaway-winners">
                  {' '}
                  www.Lenddit.com/giveaway-winners
                </a>{' '}
                once all winners have been confirmed and verified.
              </p>
              <p>SPONSOR: Lenddit, Inc, P.O. Box 20662 Columbus, OH 43220.</p>
              <p>ADMINISTRATOR: Lenddit, Inc, P.O. Box 20662 Columbus, OH 43220.</p>
              <p>Gift Card Manufacture is not Sponsor or Participant in this Sweepstakes.</p>
              <p>
                ©2023. Lenddit, Inc. All rights reserved. These Official Rules may not be copied,
                edited, or used for any other purpose, commercial or otherwise, without the express
                written consent of Lenddit, Inc.
              </p>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default SweepstakesPage;
